/* eslint-disable jira/filename-case */
import type { PreloadedQuery } from 'react-relay';
import {
	createRelayResource,
	RELAY_RESOURCE_TYPE,
} from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';
import ServiceDeskPortalSettingsRelayQuery, {
	type ClassicPortalSettingsQuery,
} from './__generated__/ClassicPortalSettingsQuery.graphql.ts';

export const serviceDeskPortalClassicSettingsResource: RouteResource<
	PreloadedQuery<ClassicPortalSettingsQuery, Record<string, unknown>>
> = createRelayResource<ClassicPortalSettingsQuery>({
	type: `${RELAY_RESOURCE_TYPE}_SERVICE_DESK_PORTAL_CLASSIC_SETTINGS`,
	getQuery: (_, { tenantContext: { cloudId } }) => ({
		parameters: ServiceDeskPortalSettingsRelayQuery,
		variables: { cloudIdString: cloudId, cloudId },
		options: { fetchPolicy: 'store-and-network' },
	}),
	isCritical: true,
});
